import React from 'react';

export default function FormActions({
  submitLabel = 'Guardar',
  cancelLabel = 'Cancelar',
  onCancel,
  loading = false,
  showCancel = true,
  btnPrimary,
  btnOutline
}) {
  return (
    <div className="flex flex-col-reverse sm:flex-row gap-2 items-stretch sm:items-center justify-end">
      {showCancel && onCancel && (
        <button
          type="button"
          onClick={onCancel}
          className={`px-5 py-2.5 rounded-xl text-sm font-semibold border transition-colors ${btnOutline}`}
        >
          {cancelLabel}
        </button>
      )}
      <button
        type="submit"
        disabled={loading}
        className={`px-5 py-2.5 rounded-xl text-sm font-semibold transition-colors disabled:opacity-50 ${btnPrimary}`}
      >
        {loading ? 'Guardando…' : submitLabel}
      </button>
    </div>
  );
}
